import React, { useContext, useMemo, useState } from 'react';
import { Input, notification, Row } from 'antd';
import { useQuery } from 'react-query';
import { DataGridColDef } from 'components/DataGrid/DataGrid';
import AntButton from 'components/Button';
import DF from 'DisplayFramework';
import DataGrid from 'components/DataGrid';
import {
  getProctaskConseqListByCriteria,
  GetProctaskConseqListByCriteriaParams,
  ProctaskConseqListResponse,
} from 'services/workflow';
import ParListSelect from 'components/ParListSelect';
import { ThunderboltTwoTone } from '@ant-design/icons';
import { manualRunPrintDocumentOrSendEmail } from 'services/printingService';
import ThirdPartyInput from 'components/ThirdPartyInput';
import ProposalSelect from 'components/ProposalSelect';
import AssetSelect from 'components/AssetSelect';
import SupplierInvoiceSelect from 'components/SupplierInvoiceSelect';
import GuarantySelect from 'components/GuarantySelect';
import CollectionSelect from 'components/CollectionSelect';
import { genInvoiceFees } from 'services/clientInvoice';
import ButtonOperation from 'components/ButtonOperation';
import ThirdPartyModal from 'pages/ThirdParty/ThirdPartyDetail/ThirdPartyModal';
import ModalControllerNV from 'components/ModalControllerNV';
import ProposalModal from 'pages/ProposalV3/ProposalModal';
import AssetDetails from 'pages/Asset/AssetDetail';
import SIDetail from 'pages/SupplierInvoice/SIDetail';
import GuarantDetailModal from 'pages/guaranty/guarantyDetails/guarantyDetailsModal';
import CIDetail from 'pages/ClientInvoice/CIDetail';
import CollectionDetailModal from 'components/CollectionDetailModal';
import PayementModal from 'pages/Payment/PayementModal';
import PaymentSelect from 'components/PaymentSelect';
import ClientInvoiceSelect from 'components/ClientInvoiceSelect';
import { AuthContext } from 'components/Auth/Auth';

export type ProcTaskConseqListProps = {
  objectid?: number;
  procmodule?: string;
};
const ProcTaskConseqList = ({
  objectid,
  procmodule,
}: ProcTaskConseqListProps) => {
  const [search, setSearchs] = useState(false);
  const { isInspect } = useContext(AuthContext);

  const initialSearchParams: GetProctaskConseqListByCriteriaParams = {
    conseqtype: '',
    receivertype: '',
    objectid: '' as any,
    procmodule: '',
  };
  const [searchParams, setSearchParams] =
    useState<GetProctaskConseqListByCriteriaParams>(initialSearchParams);

  const { data, refetch, isFetching } = useQuery(
    ['getProctaskConseqListByCriteria', searchParams],
    () =>
      getProctaskConseqListByCriteria(searchParams).then(
        (res) => res.list || []
      ),
    { enabled: search }
  );

  const [checkdocmodule, setcheckdocmodule] = useState('');
  const [loadingnotif, setloadingnotif] = useState<any>();

  const handleRunManual = (item: any) => {
    setloadingnotif(item.notifid);
    manualRunPrintDocumentOrSendEmail({
      doccode: item.conseqcode,
      conseqid: item.conseqid,
      notifid: item.notifid,
      entityid: item.objectid,
      entity: item.procmodule,
      subentityid: item.subentityid??0,
      subentity: item.subentity??'',
      flagEmail: item.conseqtype === 'EMAIL' ? 'true' : 'false',
      emailTo: item.emailto,
      emailCc: item.emailcc,
    })
      .then((response) => {
        if (response.code === '200') {
          notification.success({
            message:
              item.conseqtype === 'EMAIL'
                ? `${item.conseqtype}  successfully created`
                : item.conseqtype === 'PRINT'
                ? `${item.conseqtype}  successfully created`
                : item.conseqtype === 'SMS'
                ? `${item.conseqtype}  successfully created`
                : item.conseqtype === 'NOTIF'
                ? `${item.conseqtype}  successfully created`
                : '',
          });
          refetch();
        } else {
          notification.error({
            message: response.message,
            description: response.description,
          });
        }
        setloadingnotif(null);
      })
      .catch(() => {
        setloadingnotif(null);
      });
  };
  const InvoicehandleRunManual = (item: any, modet: string) => {
    genInvoiceFees({
      ctetype: item.conseqcode,
      entity: item.procmodule,
      entityid: item.objectid,
      entitytarget: item.entitytarget,
      entitytaskidtarget: item.entitytaskidtarget,
      notifid: item.notifid,
    }).then((response) => {
      if (response.code === '200') {
        notification.success({
          message: `${item.conseqtype}  successfully created`,
        });
        refetch();
      } else {
        notification.error({
          message: response.message,
          description: response.description,
        });
      }
    });
  };

  const columns = useMemo<DataGridColDef<ProctaskConseqListResponse>[]>(
    () => [
      {
        dataIndex: 'procmodulelabel',
        filtrable: 'procmodule',
        filterComponent: (
          <ParListSelect
            onClear={() => {
              setcheckdocmodule('');
            }}
            allowClear
            parcode="DOCMODULE"
            onSelect={(e) => {
              setcheckdocmodule(e);
            }}
          />
        ),
        width: '100px',
      },

      {
        dataIndex: 'objectreference',
        filtrable: 'objectid',
        filterComponent:
          checkdocmodule === 'THIRDPARTY' ? (
            <ThirdPartyInput
              onlytpid
              onChange={(e: any) => {
                searchParams.objectid = e;
              }}
            />
          ) : checkdocmodule === 'PROPOSAL' ? (
            <ProposalSelect
              onChange={(e: any) => {
                searchParams.objectid = e.ctrid;
              }}
              isCreate
              onlyctrid
            />
          ) : checkdocmodule === 'ASSET' ? (
            <AssetSelect
              onlyAssetId
              onChange={(e: any) => {
                searchParams.objectid = e.assetid;
              }}
            />
          ) : checkdocmodule === 'SINVOICE' ? (
            <SupplierInvoiceSelect
              onlysiid
              onChange={(e: any) => {
                searchParams.objectid = e.value;
              }}
            />
          ) : checkdocmodule === 'CINVOICE' ? (
            <ClientInvoiceSelect
              onChange={(e: any) => {
                searchParams.objectid = e;
              }}
              onlyCiid
            />
          ) : checkdocmodule === 'CONTRACT' ? (
            <ProposalSelect
              onChange={(e: any) => {
                searchParams.objectid = e;
              }}
              PropOrProd="PROD"
              onlyctrid
            />
          ) : checkdocmodule === 'GUARANTY' ? (
            <GuarantySelect
              onChange={(e: any) => {
                searchParams.objectid = e.guarid;
              }}
            />
          ) : checkdocmodule === 'COLLECTION' ? (
            <CollectionSelect
              onlyColid
              onChange={(e: any) => {
                searchParams.objectid = e.colid;
              }}
            />
          ) : checkdocmodule === 'PAYMENT' ? (
            <PaymentSelect
              onlyPayid
              onChange={(e: any) => {
                searchParams.objectid = e.payid;
              }}
            />
          ) : (
            <Input disabled defaultValue="Please select an object" />
          ),
        width: '150px',
        render: (value, record) => (
          <>
            {record.procmodule === 'THIRDPARTY' && (
              <ModalControllerNV
                content={({ setVisible, visible }) => (
                  <a onClick={() => setVisible(true)}>
                    {record.objectreference}
                  </a>
                )}
                modal={({ setVisible, visible }) => (
                  <ThirdPartyModal
                    tpId={record.procid}
                    visible={visible}
                    onCancel={() => setVisible(false)}
                    onSuccess={() => setVisible(false)}
                    title={record.procmodule}
                    iscreate={false}
                  />
                )}
              />
            )}
            {record.procmodule === 'PROPOSAL' && (
              <ModalControllerNV
                modal={({ setVisible, visible }) => (
                  <ProposalModal
                    ctrid={record.objectid}
                    visible={visible}
                    onCancel={() => setVisible(false)}
                    onSuccess={() => setVisible(false)}
                    title=""
                    iscreate={false}
                  />
                )}
                content={({ setVisible, visible }) => (
                  <a onClick={() => setVisible(true)}>
                    {record.objectreference}
                  </a>
                )}
              />
            )}
            {record.procmodule === 'ASSET' && (
              <ModalControllerNV
                content={({ setVisible, visible }) => (
                  <a
                    onClick={() => {
                      setVisible(true);
                    }}
                  >
                    {record.objectreference}
                  </a>
                )}
                modal={({ setVisible, visible }) => (
                  <AssetDetails
                    assetid={record.objectid}
                    onCancel={() => setVisible(false)}
                    showAsModal
                    visible={visible}
                    phaseprop="PROPOSAL"
                    iscreate={false}
                  />
                )}
              />
            )}
            {record.procmodule === 'SINVOICE' && (
              <ModalControllerNV
                content={({ setVisible, visible }) => (
                  <a
                    onClick={() => {
                      setVisible(true);
                    }}
                  >
                    {record.objectreference}
                  </a>
                )}
                modal={({ setVisible, visible }) => (
                  <SIDetail
                    siid={record.objectid}
                    onCancel={() => setVisible(false)}
                    showAsModal
                    visible={visible}
                    showButtons={false}
                  />
                )}
              />
            )}
            {record.procmodule === 'CONTRACT' && (
              <ModalControllerNV
                content={({ setVisible, visible }) => (
                  <a
                    onClick={() => {
                      setVisible(true);
                    }}
                  >
                    {record.objectreference}
                  </a>
                )}
                modal={({ setVisible, visible }) => (
                  <ProposalModal
                    ctrid={record.objectid}
                    visible={visible}
                    onCancel={() => setVisible(false)}
                    onSuccess={() => setVisible(false)}
                    title=""
                    iscreate={false}
                  />
                )}
              />
            )}
            {record.procmodule === 'GUARANTIES' && (
              <ModalControllerNV
                content={({ setVisible, visible }) => (
                  <a
                    onClick={() => {
                      setVisible(true);
                    }}
                  >
                    {record.objectreference}
                  </a>
                )}
                modal={({ setVisible, visible }) => (
                  <GuarantDetailModal
                    guarId={String(record.objectid)}
                    visible={visible}
                    onCancel={() => setVisible(false)}
                    onSuccess={() => setVisible(false)}
                    title={record.objectreference}
                    iscreate={false}
                  />
                )}
              />
            )}
            {record.procmodule === 'CINVOICE' && (
              <ModalControllerNV
                content={({ setVisible, visible }) => (
                  <a
                    onClick={() => {
                      setVisible(true);
                    }}
                  >
                    {record.objectreference}
                  </a>
                )}
                modal={({ setVisible, visible }) => (
                  <CIDetail
                    ciid={Number(record.objectid)}
                    onCancel={() => setVisible(false)}
                    showAsModal
                    visible={visible}
                  />
                )}
              />
            )}{' '}
            {record.procmodule === 'COLLECTION' && (
              <ModalControllerNV
                content={({ setVisible, visible }) => (
                  <a
                    onClick={() => {
                      setVisible(true);
                    }}
                  >
                    {record.objectreference}
                  </a>
                )}
                modal={({ setVisible, visible }) => (
                  <CollectionDetailModal
                    visible={visible}
                    onCancel={() => setVisible(false)}
                    colidp={Number(record.objectid)}
                  />
                )}
              />
            )}
            {record.procmodule === 'PAYMENT' && (
              <ModalControllerNV
                content={({ setVisible, visible }) => (
                  <a
                    onClick={() => {
                      setVisible(true);
                    }}
                  >
                    {record.objectreference}
                  </a>
                )}
                modal={({ setVisible, visible }) => (
                  <PayementModal
                    visible={visible}
                    onCancel={() => setVisible(false)}
                    payid={Number(record.objectid)}
                  />
                )}
              />
            )}{' '}
          </>
        ),
      },
      {
        dataIndex: 'notifmessage',
      },

      {
        dataIndex: 'conseqtype',
        filtrable: 'conseqtype',
        width: 100,

        filterComponent: (
          <ParListSelect parcode="CONSEQTYPE" style={{ width: '100%' }} />
        ),
      },

      {
        dataIndex: 'emailcc',
      },
      {
        dataIndex: 'emailto',
      },
      {
        dataIndex: 'conseqstatus',
        width: 150,
        filtrable: 'conseqstatus',
        filterComponent: (
          <ParListSelect parcode="CONSEQTYPE" style={{ width: '100%' }} />
        ),
      },
      {
        dataIndex: 'conseqstatusdate',
        width: 150,
      },
      {
        dataIndex: 'action',
        width: 150,
        fixed: 'right',
        render: (text, record) => (
          <Row gutter={3}>
            {record.conseqtype === 'INVOICEF' ? (
              <ButtonOperation
                onClick={() =>
                  !isInspect && InvoicehandleRunManual(record, 'RENTAL')
                }
                comcode="runservice"
                type="primary"
                htmlType="submit"
              />
            ) : (
              <AntButton
                onClick={() => !isInspect && handleRunManual(record)}
                loading={loadingnotif}
                comcode="runManual"
                icon={
                  <ThunderboltTwoTone twoToneColor="#eb2f96" width="200px" />
                }
              />
            )}
          </Row>
        ),
      },
    ],
    [checkdocmodule, searchParams, isInspect]
  );
  const columnsFilter = () => {
    let columnsFiltred = columns;
    if (procmodule && objectid) {
      columnsFiltred = columnsFiltred.filter((column) => {
        return (
          column.dataIndex !== 'procmodule' && column.dataIndex !== 'objectid'
        );
      });
    } else if (procmodule) {
      columnsFiltred = columnsFiltred.filter((column) => {
        return column.dataIndex !== 'procmodule';
      });
    }

    return columnsFiltred;
  };

  return (
    <DF.Provider pagcode="proctaskconseqlist">
      <DataGrid
        isLoading={isFetching}
        rowKey="id"
        dataSource={data}
        titleComcode="ProcTaskConseqList"
        columns={columnsFilter()}
        onSearch={(values) => {
          setSearchs(true);
          setSearchParams({
            ...searchParams,
            conseqtype: values.conseqtype,
            receivertype: values.receivertype,
            objectid: values.objectid,
            procmodule: checkdocmodule,
          });
        }}
        onClear={() => {
          setcheckdocmodule('');
          setSearchParams({
            conseqtype: '',
            receivertype: '',
            objectid: 0,
            procmodule: '',
          });
        }}
        initialSearchValues={searchParams}
      />
    </DF.Provider>
  );
};

export default ProcTaskConseqList;
